module.exports = __webpack_public_path__ + "img/img3.9b934b7a.jpg";